export default "__VITE_ASSET__635758ac__"